import React from "react";
import {connect} from 'dva';

function SubmitSuccess(props) {

    const { ids, deployConfigInfo, LOCALE_HTML, dispatch } = props;
    const len = (deployConfigInfo.items || []).length;
    const { historyTicketFlag } = deployConfigInfo.item || {};

    const setShowType = (showType) => {
        if(len === 1 && showType === 0){
            dispatch({
                type: 'app/getList',
                payload: {
                    ...ids,
                    templateId: deployConfigInfo.items[0].templateId,
                    showType: 1
                }
            });
        } else {
            dispatch({
                type: 'app/changeItem',
                payload: showType
            })
        }
    };

    return (
        <div className="success-wrap submit-success-wrap">
            <div className="success-icon">
                <svg><use xlinkHref="#icontijiaochenggong"/></svg>
            </div>
            <div className="success-title">{LOCALE_HTML['msg.success']}</div>
            <div className="success-tip">{LOCALE_HTML['success.desc']}</div>
            <button onClick={() => setShowType(0)} className="zc-success-btn">{LOCALE_HTML['completed']}</button>
            {
                historyTicketFlag === 1 ? <div className="go-list" onClick={() => setShowType(3)}>{LOCALE_HTML['to.record']}</div> : null
            }
        </div>
    )
}

const mapState = state => {
    const {ids, deployConfigInfo} = state.app;
    const {LOCALE_HTML} = state.locale;
    return {
        ids,
        deployConfigInfo,
        LOCALE_HTML
    };
};

export default connect(mapState)(SubmitSuccess);